import { IBaseResponseData, INomination } from '../index.js'

/**
 * This interface defines the object that is returned by the Congress API when
 * you request a list of nominations from the `/nomination` endpoint.
 */
export interface INominationResponse extends IBaseResponseData {
  nominations: INomination[]
}
